(function () {
  const state = window.__cartMockupPreviewState || (window.__cartMockupPreviewState = {});

  function getRoot() {
    return document.querySelector('[data-cart-mockup-data]');
  }

  function getTargets() {
    return {
      root: getRoot(),
      cartItems: document.querySelector('cart-items.cart-items-box'),
      itemsTarget: document.querySelector('#main-cart-items .js-contents-cart-items'),
      bannerHost: document.querySelector('.cart-expiry-banner-dekor'),
      bannerTimer: document.querySelector('[data-cart-expiry-timer]'),
      summaryHost: document.getElementById('main-cart-footer'),
      summaryValue: document.querySelector('#main-cart-footer .totals__total-value'),
      checkoutButton: document.querySelector('#main-cart-footer .cart__checkout-button'),
    };
  }

  function inDesignMode() {
    return Boolean(window.Shopify && window.Shopify.designMode);
  }

  function shouldApply(root, cartItems) {
    if (!root || !cartItems) return false;

    const enableThemeEditor = root.dataset.enableThemeEditor === 'true';
    const enableEmptyCart = root.dataset.enableEmptyCart === 'true';
    const emptyCart = cartItems.classList.contains('is-empty');

    if (enableThemeEditor && inDesignMode()) return true;
    if (enableEmptyCart && emptyCart) return true;

    return false;
  }

  function capture(targets) {
    if (state.itemsTarget !== targets.itemsTarget && targets.itemsTarget) {
      state.itemsTarget = targets.itemsTarget;
      state.itemsHTML = targets.itemsTarget.innerHTML;
    }

    if (state.bannerTimer !== targets.bannerTimer && targets.bannerTimer) {
      state.bannerTimer = targets.bannerTimer;
      state.bannerTimerText = targets.bannerTimer.textContent;
    }

    if (state.summaryValue !== targets.summaryValue && targets.summaryValue) {
      state.summaryValue = targets.summaryValue;
      state.summaryText = targets.summaryValue.textContent;
    }

    if (state.checkoutButton !== targets.checkoutButton && targets.checkoutButton) {
      state.checkoutButton = targets.checkoutButton;
      state.checkoutDisabled = targets.checkoutButton.disabled;
    }

    if (state.cartItems !== targets.cartItems && targets.cartItems) {
      state.cartItems = targets.cartItems;
      state.cartItemsEmpty = targets.cartItems.classList.contains('is-empty');
    }

    if (state.bannerHost !== targets.bannerHost && targets.bannerHost) {
      state.bannerHost = targets.bannerHost;
      state.bannerEmpty = targets.bannerHost.classList.contains('is-empty');
    }

    if (state.summaryHost !== targets.summaryHost && targets.summaryHost) {
      state.summaryHost = targets.summaryHost;
      state.summaryEmpty = targets.summaryHost.classList.contains('is-empty');
    }
  }

  function restore(targets) {
    document.documentElement.classList.remove('cart-mockup-active');

    if (targets.itemsTarget && typeof state.itemsHTML === 'string') {
      targets.itemsTarget.innerHTML = state.itemsHTML;
    }

    if (targets.bannerTimer && typeof state.bannerTimerText === 'string') {
      targets.bannerTimer.textContent = state.bannerTimerText;
    }

    if (targets.summaryValue && typeof state.summaryText === 'string') {
      targets.summaryValue.textContent = state.summaryText;
    }

    if (targets.checkoutButton && typeof state.checkoutDisabled === 'boolean') {
      targets.checkoutButton.disabled = state.checkoutDisabled;
    }

    if (targets.cartItems && typeof state.cartItemsEmpty === 'boolean') {
      targets.cartItems.classList.toggle('is-empty', state.cartItemsEmpty);
    }

    if (targets.bannerHost && typeof state.bannerEmpty === 'boolean') {
      targets.bannerHost.classList.toggle('is-empty', state.bannerEmpty);
    }

    if (targets.summaryHost && typeof state.summaryEmpty === 'boolean') {
      targets.summaryHost.classList.toggle('is-empty', state.summaryEmpty);
    }
  }

  function apply() {
    const targets = getTargets();
    const root = targets.root;

    if (!root) {
      restore(targets);
      return;
    }

    capture(targets);

    if (!shouldApply(root, targets.cartItems)) {
      restore(targets);
      return;
    }

    document.documentElement.classList.add('cart-mockup-active');

    const itemsTemplate = root.querySelector('[data-cart-mockup-items]');
    if (targets.itemsTarget && itemsTemplate) {
      targets.itemsTarget.innerHTML = itemsTemplate.innerHTML;
    }

    if (targets.bannerTimer) {
      targets.bannerTimer.textContent = root.dataset.timer || targets.bannerTimer.textContent;
    }

    if (targets.summaryValue) {
      targets.summaryValue.textContent = root.dataset.subtotal || targets.summaryValue.textContent;
    }

    if (targets.checkoutButton) {
      targets.checkoutButton.disabled = false;
    }

    if (targets.cartItems) {
      targets.cartItems.classList.remove('is-empty');
    }

    if (targets.bannerHost) {
      targets.bannerHost.classList.remove('is-empty');
    }

    if (targets.summaryHost) {
      targets.summaryHost.classList.remove('is-empty');
    }
  }

  document.addEventListener('DOMContentLoaded', apply);
  document.addEventListener('shopify:section:load', apply);
  document.addEventListener('shopify:section:reorder', apply);
  document.addEventListener('shopify:section:select', apply);
})();
